import { useEffect, useMemo } from "react"
import {
  BottomNavigation as MuiBottomNavigation,
  BottomNavigationAction,
  Box,
  useTheme,
} from "@mui/material"
import clsx from "clsx"
import { Link, useLocation } from "react-router-dom"
import qs from "qs"
import { useTranslation } from "providers/i18n"
import { MoreIcon } from "../icons"
import { Sidebar } from "components/Sidebar"
import { useAppUI } from "providers/ui"
import { getIcon } from "utils/icon"
import { kebabCase } from "lodash"

export const MobileNavigation = ({
  value,
  bottomNavigations = [],
  navigations = [],
}) => {
  const location = useLocation()
  const { sidebarState, setSidebarState } = useAppUI()

  const { t } = useTranslation()

  const theme = useTheme()
  const styleOverrides =
    theme.components[`AppMobileNavigation`]?.styleOverrides || {}
  const { root, menuButton, moreButton } = styleOverrides

  // Close Drawer when url changed
  useEffect(() => {
    setSidebarState(false)
  }, [location.pathname, setSidebarState])

  const moreIcon = useMemo(
    () => getIcon(theme?.assets?.moreIcon) || <MoreIcon />,
    [theme]
  )

  return (
    <>
      <Box sx={root}>
        <MuiBottomNavigation value={value} showLabels>
          {bottomNavigations.map((nav) => {
            const isActive =
              value === `${nav.to}` ||
              value === `${nav.to}?${qs.stringify(nav.qs)}`
            const activeIcon = nav.active_icon || nav.icon
            return (
              <BottomNavigationAction
                id={nav.label}
                data-testid={nav.label}
                sx={menuButton}
                component={Link}
                key={nav.to}
                label={t([`navigation.${nav.label}`, nav.label])}
                to={`${nav.to}?${qs.stringify(nav.qs)}`}
                value={nav.value || nav.to}
                icon={isActive ? activeIcon : nav.icon}
                className={clsx(kebabCase(nav.label))}
              />
            )
          })}
          <BottomNavigationAction
            id="more-button"
            data-testid="more-button"
            sx={moreButton}
            label={t("navigation.More")}
            onClick={() => setSidebarState(true)}
            icon={moreIcon}
          />
        </MuiBottomNavigation>
      </Box>

      <Sidebar
        open={sidebarState}
        onClose={() => setSidebarState(false)}
        anchor="left"
        navigations={navigations}
      />
    </>
  )
}
